import { WEEKDAYS } from './catalog.js';

export type HoursPeriodDraft = { open: string; close: string };

export type HoursDayDraft = {
  open: string;
  close: string;
  closed: boolean;
  periods?: HoursPeriodDraft[];
};

export type HoursDraft = Record<string, HoursDayDraft>;

/** 10-05a: max 4 periods per weekday (breaks). */
export const MAX_OPENING_PERIODS = 4;

export function periodsFromDayDraft(day: HoursDayDraft | undefined): HoursPeriodDraft[] {
  if (!day || day.closed) return [];
  if (day.periods?.length) {
    return day.periods.slice(0, MAX_OPENING_PERIODS).map((period) => ({
      open: period.open || '09:00',
      close: period.close || '22:00',
    }));
  }
  return [{ open: day.open || '09:00', close: day.close || '22:00' }];
}

export function withDayPatch(day: HoursDayDraft, patch: Partial<HoursDayDraft>): HoursDayDraft {
  const closed = patch.closed ?? day.closed;
  let periods: HoursPeriodDraft[];
  if (patch.periods) {
    periods = patch.periods.slice(0, MAX_OPENING_PERIODS);
  } else {
    periods = periodsFromDayDraft({ ...day, closed: false });
    if (periods.length === 0) periods = [{ open: '09:00', close: '22:00' }];
    if (patch.open != null || patch.close != null) {
      periods = [
        {
          open: patch.open ?? periods[0]?.open ?? '09:00',
          close: patch.close ?? periods[0]?.close ?? '22:00',
        },
        ...periods.slice(1),
      ];
    }
  }
  const first = periods[0] ?? { open: '09:00', close: '22:00' };
  return { open: first.open, close: first.close, closed, periods };
}

export const HOURS_TEMPLATES: { id: string; label: string; draft: HoursDraft }[] = [
  {
    id: 'standard',
    label: 'Standard week (09:00–22:00)',
    draft: Object.fromEntries(
      WEEKDAYS.map((day) => [day, { open: '09:00', close: '22:00', closed: false }]),
    ) as HoursDraft,
  },
  {
    id: 'late',
    label: 'Late kitchen (12:00–23:00, closed Monday)',
    draft: Object.fromEntries(
      WEEKDAYS.map((day) => [
        day,
        day === 'MONDAY'
          ? { open: '12:00', close: '23:00', closed: true }
          : { open: '12:00', close: '23:00', closed: false },
      ]),
    ) as HoursDraft,
  },
  {
    id: 'weekday',
    label: 'Weekdays only (08:00–18:00)',
    draft: Object.fromEntries(
      WEEKDAYS.map((day) => [
        day,
        day === 'SATURDAY' || day === 'SUNDAY'
          ? { open: '08:00', close: '18:00', closed: true }
          : { open: '08:00', close: '18:00', closed: false },
      ]),
    ) as HoursDraft,
  },
];
